import { BaseService } from "../BaseService";
import { TherapistEventBaseService } from "./TherapistEventBaseService";
import { AuthService } from "../auth/auth.service";
import { environment } from '../../../../src/environments/environment';
import { HttpClient } from "@angular/common/http";
import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from "rxjs";
import { catchError, concatMap, delay, map, retryWhen, take } from 'rxjs/operators';
import { ApiResult } from "../../models/ApiResult";
import { TherapistEventModel } from "../../models/api/TherapistEventModel";
import { TherapistEventFindResultModel } from "../../models/api/TherapistEventFindResultModel";
import { TherapistEventDetailsModel } from "../../models/api/TherapistEventDetails";

@Injectable({
    providedIn: 'root'
})

export class TherapistEventService extends TherapistEventBaseService {

    constructor(private h: HttpClient, private r: Router, private a: AuthService) {
        super(h, r, a);
    };

  /// <summary>
  /// GET: Retrieves a custom TherapistEventDetailsModel obj record from the database
  /// /TherapistEvent/activebytherapist
  /// </summary>
  /// <param name="therapistid"></param>
  /// <returns></returns>
  public getActiveByTherapist(): Observable<TherapistEventDetailsModel> {

    // Get Single TherapistEvent Record

    const url = `${super.getBaseUrl()}/activebytherapist`;

    if (!environment.production)
      console.log("Get ActiveByTherapist: Calling " + url);

    return this.h.get<TherapistEventDetailsModel>(url)
      .pipe(
        map(next => {
          let o: TherapistEventDetailsModel = Object.assign(new TherapistEventDetailsModel(), next);
          return o;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Retrieves a list of custom TherapistEventDetailsModel objs
  /// /TherapistEvent/bytherapistandevent
  /// </summary>
  /// <param name="therapistid"></param>
  /// <param name="eventid"></param>
  /// <returns></returns>
  public getByTherapistAndEvent(therapistid: number, eventid: number): Observable<TherapistEventDetailsModel[]> {

    // Get Single TherapistEvent Record

    const url = `${super.getBaseUrl()}/bytherapistandevent?therapistid=${therapistid}&eventid=${eventid}`;

    if (!environment.production)
      console.log("Get ActiveByTherapist: Calling " + url);

    return this.h.get<TherapistEventDetailsModel[]>(url)
      .pipe(
        map(next => {
          for (var i = 0; i < next.length; i++) {
            let o: TherapistEventDetailsModel = Object.assign(new TherapistEventDetailsModel(), next[i]);
            next[i] = o;
          }

          return next;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// GET: Retrieves a list of custom TherapistEventDetailsModel objs
  /// /TherapistEvent/byevent
  /// </summary>
  /// <param name="eventid"></param>
  /// <returns></returns>
  public getByEvent(eventid: number): Observable<TherapistEventDetailsModel[]> {

    // Get Single TherapistEvent Record

    const url = `${super.getBaseUrl()}/byevent?eventid=${eventid}`;

    if (!environment.production)
      console.log("Get ByEvent: Calling " + url);

    return this.h.get<TherapistEventDetailsModel[]>(url)
      .pipe(
        map(next => {
          for (var i = 0; i < next.length; i++) {
            let o: TherapistEventDetailsModel = Object.assign(new TherapistEventDetailsModel(), next[i]);
            next[i] = o;
          }

          return next;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// DELETE: Deletes an existing TherapistEvent record from the database
  /// /TherapistEvent/{therapisteventid}
  /// </summary>
  /// <param name="therapisteventid"></param>
  /// <returns></returns>
  public deleteByTherapistAndEvent(therapistid: number, eventid: number): Observable<ApiResult> {
    // Delete All  Matching TherapistEvent Records

    const url = `${super.getBaseUrl()}/bytherapistandevent/${therapistid}/${eventid}`;

    if (!environment.production)
      console.log("Delete By Therapist And Event: Calling " + url);

    return this.h.delete<ApiResult>(url)
      .pipe(
        map(next => {
          let o: ApiResult = new ApiResult();
          o.success = true;
          return o;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }

  /// <summary>
  /// POST: Adds a range of new TherapistEvent records to the database, for each day of an event
  /// /TherapistEvent/range/{eventid}/{therapistid}/{active}
  /// </summary>
  /// <param name="eventid"></param>
  /// <param name="therapistid"></param>
  /// <param name="active"></param>
  /// <returns></returns>
  public createTherapistEventRange(eventid: number, therapistid: number, active: boolean): Observable<TherapistEventDetailsModel[]> {
    
    const url = `${super.getBaseUrl()}/range/${eventid}/${therapistid}/${active}`;

    if (!environment.production)
      console.log("Create TherapistEventRange:Calling " + url);

    return this.h.post<TherapistEventDetailsModel[]>(url, null)
      .pipe(
        map(next => {

          for (var i = 0; i < next.length; i++) {
            let o: TherapistEventDetailsModel = Object.assign(new TherapistEventDetailsModel(), next[i]);
            next[i] = o;
          }

          return next;
        }),
        retryWhen(errors =>
          errors.pipe(
            concatMap((error, count) => {
              if (count > this.RETRY_CEILING) return throwError(error);
              return this.tokenCheckAndRefresh(error);
            }),
            delay(1000),
          ),
        ),
        catchError(this.errorHandler)
      );
  }
}
